export default __webpack_public_path__ + "static/media/bg08.ae6caa96.svg";